import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/vendor-profiles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/vendor-profiles', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/vendor-profiles/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/vendor-profiles/${data.vendor_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient.delete(`/api/vendor-profiles/${id}`).then(response => Promise.resolve(response.data))
}

export const getCompany = (Options = {}) => {
  return httpClient
    .get('/api/vendor-profiles/companies', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default { get, store, find, update, destroy, getCompany }
